import { createAction, props } from '@ngrx/store';
import { CalculationModelsState, CalculationState } from './calculation.state';
import { AnnexDto } from '../../api/models/annex-dto';
import { CalculationTypeEnum } from '../../api/models/calculation-type-enum';
import { RainSystemMeasurementsDto } from '../../api/models/rain-system-measurements-dto';
import { TileByHeightDto } from '../../api/models/tile-by-height-dto';
import { ContactDto } from '../../api/models/contact-dto';
import { OfferDto } from '../../api/models/offer-dto';
import { CalculationDto } from '../../api/models/calculation-dto';
import { ShoppingCartDto } from '../../api/models/shopping-cart-dto';

export enum CalculationActions {
  SET_ACTIVE_TAB = 'SetActiveTab',
  LOAD_CALCULATION = 'LoadCalculation',
  CHANGE_IS_COMPANY = 'ChangeIsCompany',
  SET_ACCESSORIES = 'SetAccessories',
  SET_MODELS = 'SetModels',
  SET_MEASUREMENTS = 'SetMeasurements',
  ADD_ANNEX = 'AddAnnex',
  UPDATE_ANNEX = 'UpdateAnnex',
  REMOVE_ANNEX = 'RemoveAnnex',
  SET_RAIN_SYSTEM = 'SetRainSystem',
  UPDATE_RAIN_SYSTEM = 'UpdateRainSystem',
  SET_CUSTOM_TILES = 'SetCustomTiles',
  SET_CONTACT = 'SetContact',
  SET_CALCULATE_ACCESSORIES = 'SetCalculateAccessories',
  SET_GDPR = 'SetGdpr',
  SET_STEPPER_STEP = 'SetStepperStep',
  SET_CALCULATION = 'SetCalculation',
  SET_CALCULATION_PARTIAL_PAYMENT = 'SetCalculationPartialPayment',
  SET_OFFER = 'SetOffer',
  SET_PARTIAL_PAYMENT = 'SetPartialPayment',
  SET_CART = 'SetCart',
  EMPTY_CART = 'EmptyCart',
  RESET = 'Reset',
  SET_LOADED = 'SetLoaded',
}

export const loadCalculation = createAction(
  CalculationActions.LOAD_CALCULATION,
  props<{ payload: CalculationState; roofType: CalculationTypeEnum }>(),
);

export const setIsCompany = createAction(CalculationActions.CHANGE_IS_COMPANY, props<{ isCompany: boolean }>());
export const setStepperStep = createAction(CalculationActions.SET_STEPPER_STEP, props<{ stepperStep: number }>());
export const setGdpr = createAction(CalculationActions.SET_GDPR, props<{ isGdprAccepted: boolean }>());
export const setActiveTab = createAction(CalculationActions.SET_ACTIVE_TAB, props<{ roofType: CalculationTypeEnum }>());
export const setAccessories = createAction(CalculationActions.SET_ACCESSORIES, props<{ accessories: any }>());
export const setModels = createAction(
  CalculationActions.SET_MODELS,
  props<{ models: CalculationModelsState; isLoaded?: boolean }>(),
);
export const setMeasurements = createAction(CalculationActions.SET_MEASUREMENTS, props<{ measurements: any }>());
export const addAnnex = createAction(CalculationActions.ADD_ANNEX, props<{ annex: AnnexDto }>());
export const updateAnnex = createAction(CalculationActions.UPDATE_ANNEX, props<{ annex: AnnexDto; index: number }>());
export const removeAnnex = createAction(CalculationActions.REMOVE_ANNEX, props<{ index: number }>());
export const setRainSystem = createAction(
  CalculationActions.SET_RAIN_SYSTEM,
  props<{ rainSystem: RainSystemMeasurementsDto }>(),
);
export const updateRainSystem = createAction(
  CalculationActions.UPDATE_RAIN_SYSTEM,
  props<Partial<RainSystemMeasurementsDto>>(),
);
export const setCustomTiles = createAction(CalculationActions.SET_CUSTOM_TILES, props<{ tiles?: TileByHeightDto[] }>());
export const setContact = createAction(CalculationActions.SET_CONTACT, props<{ contact: ContactDto }>());
export const setCalculateAccessories = createAction(
  CalculationActions.SET_CALCULATE_ACCESSORIES,
  props<{ calculateAccessories: boolean }>(),
);

export const setCalculation = createAction(
  CalculationActions.SET_CALCULATION,
  props<{ calculation: CalculationDto }>(),
);
export const setCalculationPartialPayment = createAction(
  CalculationActions.SET_CALCULATION_PARTIAL_PAYMENT,
  props<{ partialPayment: boolean }>(),
);
export const setOffer = createAction(CalculationActions.SET_OFFER, props<{ offer: OfferDto }>());
export const setPartialPayment = createAction(
  CalculationActions.SET_PARTIAL_PAYMENT,
  props<{ partialPayment: boolean }>(),
);
export const setCart = createAction(CalculationActions.SET_CART, props<{ cart?: ShoppingCartDto }>());
export const emptyCart = createAction(CalculationActions.EMPTY_CART);

export const reset = createAction(CalculationActions.RESET);
